




























































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import CbxTitle from "@/views/lookups/CbxTitle.vue";
import CbxGender from "@/views/lookups/CbxGender.vue";
import CbxMaritalStatus from "@/views/lookups/CbxMaritalStatus.vue";
import CbxTaxBasisAssessment from "@/views/lookups/CbxTaxBasisAssessment.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxHealthStatus from "@/views/lookups/CbxHealthStatus.vue";
import CbxCountry from "@/views/lookups/CbxCountry.vue";
import CbxCounty from "@/views/lookups/CbxCounty.vue";
import CbxEmploymentStatus from "@/views/lookups/CbxEmploymentStatus.vue";
import CbxOccupation from "@/views/lookups/CbxOccupation.vue";
import {
  FactFindDetailsDto,
  UpdateDetailsCommand,
  CountyDto,
  OccupationDto,
  CountryDto,
  TitleDto,
  GenderDto,
  MaritalStatusDto,
  TaxBasisAssessmentDto,
  YesNoDefaultDto,
  HealthStatusDto,
  EmploymentStatusDto
} from "@/api/ClientPortalApiClient";

import ApiFactory from "../../api/ApiFactory";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    CbxTitle,
    CbxGender,
    CbxMaritalStatus,
    CbxTaxBasisAssessment,
    CbxYesNoDefault,
    CbxHealthStatus,
    CbxCountry,
    CbxCounty,
    CbxEmploymentStatus,
    CbxOccupation
  }
})
export default class FactFindPartnerDetails extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private displayModel = new FactFindDetailsDto();
  private emptyModel = new FactFindDetailsDto();
  private mode = "edit";
  private modelSig = "";

  $refs!: {
    titles: CbxTitle;
    genders: CbxGender;
    maritalStatus: CbxMaritalStatus;
    smokerStatus: CbxYesNoDefault;
    counties: CbxCounty;
    countries: CbxCountry;
    employmentStatus: CbxEmploymentStatus;
    mainForm: HTMLFormElement;
  };

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.fetchDetails(true);
  }

  private async saveDetails(): Promise<boolean> {
    if (!this.$refs.mainForm.checkValidity()) {
      this.alertService.error(
        "Form Validation Failed",
        "Please complete all required fields"
      );
      return false;
    }

    LoadingSpinnerService.Show("Saving partner details...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateDetailsCommand();

    cmd.id = this.displayModel.id;
    cmd.sP_FirstName = this.displayModel.sP_FirstName;
    cmd.sP_LastName = this.displayModel.sP_LastName;
    cmd.sP_PhoneNo = this.displayModel.sP_PhoneNo;
    cmd.sP_MobileNo = this.displayModel.sP_MobileNo;
    cmd.sP_WorkNo = this.displayModel.sP_WorkNo;
    cmd.sP_AddressLine_1 = this.displayModel.sP_AddressLine_1;
    cmd.sP_AddressLine_2 = this.displayModel.sP_AddressLine_2;
    cmd.sP_AddressLine_3 = this.displayModel.sP_AddressLine_3;
    cmd.sP_AddressLine_4 = this.displayModel.sP_AddressLine_4;
    cmd.sP_DateOfBirth = FormatDate.forApi(this.displayModel.sP_DateOfBirth);

    if (this.displayModel.sP_Title) {
      cmd.sP_TitleId = this.displayModel.sP_Title.id;
    }
    if (this.displayModel.sP_Gender) {
      cmd.sP_GenderId = this.displayModel.sP_Gender.id;
    }
    if (this.displayModel.sP_MaritalStatus) {
      cmd.sP_MaritalStatusId = this.displayModel.sP_MaritalStatus.id;
    }
    if (this.displayModel.sP_SmokerStatus) {
      cmd.sP_SmokerStatusId = this.displayModel.sP_SmokerStatus.id;
    }
    if (this.displayModel.sP_AddressCounty) {
      cmd.sP_AddressCountyId = this.displayModel.sP_AddressCounty.id;
    }
    if (this.displayModel.sP_AddressCountry) {
      cmd.sP_AddressCountryId = this.displayModel.sP_AddressCountry.id;
    }
    if (this.displayModel.sP_EmploymentStatus) {
      cmd.sP_EmploymentStatusId = this.displayModel.sP_EmploymentStatus.id;
    }

    try {
      var result = await api.factFindDetails_IndexPUT(cmd);
      if (result) {
        LoadingSpinnerService.Success("Partner details saved successfully.");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Partner details could not be saved. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Partner details could not be saved. Please try again."
      );
    }

    return false;
  }

  private fetchDetails(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading partner details...");
    const api = ApiFactory.CreateDataClient();
    api
      .factFindDetails_IndexGET(this.contactId)
      .then(result => {
        if (result) {
          this.loadDetails(result);
          this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
          if (showLoader) LoadingSpinnerService.Hide();
        } else {
          LoadingSpinnerService.Failure(
            "Could not load partner details. Please try again."
          );
        }
      })
      .catch(error => {
        LoadingSpinnerService.Failure(
          "Could not load partner details. Please try again."
        );
      });
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveDetails();
        }
      }
    }

    return true;
  }

  private isDisplayModelEmpty(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    const s2 = JSON.stringify(this.emptyModel.toJSON()).toString();

    if (s1 !== s2) return false;
    return true;
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private loadDetails(details: FactFindDetailsDto) {
    this.displayModel = details;

    this.displayModel.sP_DateOfBirth = FormatDate.forInput(
      details.sP_DateOfBirth
    );

    if (details.sP_Title) {
      this.$refs.titles.setSelected(details.sP_Title);
    }
    if (details.sP_Gender) {
      this.$refs.genders.setSelected(details.sP_Gender);
    }
    if (details.sP_MaritalStatus) {
      this.$refs.maritalStatus.setSelected(details.sP_MaritalStatus);
    }
    if (details.sP_SmokerStatus) {
      this.$refs.smokerStatus.setSelected(details.sP_SmokerStatus);
    }
    if (details.sP_AddressCounty) {
      this.$refs.counties.setSelected(details.sP_AddressCounty);
    }
    if (details.sP_AddressCountry) {
      this.$refs.countries.setSelected(details.sP_AddressCountry);
    }
    if (details.sP_EmploymentStatus) {
      this.$refs.employmentStatus.setSelected(details.sP_EmploymentStatus);
    }
  }

  private countrySelected(country: CountryDto) {
    this.displayModel.sP_AddressCountry = country;
  }
  private countySelected(county: CountyDto) {
    this.displayModel.sP_AddressCounty = county;
  }
  private titleSelected(title: TitleDto) {
    this.displayModel.sP_Title = title;
  }
  private genderSelected(gender: GenderDto) {
    this.displayModel.sP_Gender = gender;
  }
  private maritalStatusSelected(maritalStatus: MaritalStatusDto) {
    this.displayModel.sP_MaritalStatus = maritalStatus;
  }
  private smokerStatusSelected(smokerStatus: YesNoDefaultDto) {
    this.displayModel.sP_SmokerStatus = smokerStatus;
  }
  private employmentStatusSelectd(employmentStatus: EmploymentStatusDto) {
    this.displayModel.sP_EmploymentStatus = employmentStatus;
  }
}
